import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
// import { Breadcrumb, Drawer, Navbar } from '@components'
import AuthGuard from './Guards/AuthGuard';
import { SiderComponent } from '../components';
import { Desktop, Mobile } from '../utils/displayResponsive';
import { SiderComponentMobile } from '../components/layout/sider';

interface IAuthenticatedLayoutProps {
  isHidden?: boolean;
}

const AuthenticatedLayout: FunctionComponent<IAuthenticatedLayoutProps> = ({
  isHidden = false,
}) => {
  return (
    <AuthGuard>
      <div className="background-log">
        <Desktop>
          <SiderComponent>
            <Outlet />
          </SiderComponent>
        </Desktop>
        <Mobile>
          <SiderComponentMobile>
            <Outlet />
          </SiderComponentMobile>
        </Mobile>
      </div>
    </AuthGuard>
  );
};

export default AuthenticatedLayout;
